import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Grid } from "@material-ui/core";
import {
  StyledTooltip,
  TextHelperWrapper,
  TextHelperTypography,
} from "../FuiStyles";
import {
  longTextEndDate,
  rootExistedHint,
  rootWrongFormatHint,
  quickConfigurationTextHelperPlainInstance,
} from "../Constants/LongText";
import { useDebounce } from "../../../helper/customizedHooks";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import {
  checkServiceNowTicket,
  checkWBSECode,
  checkDailyDataVolume,
  checkConcurrentUsers,
  checkBenefitsExpected,
} from "./CommonFunctions";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import TextsmsIcon from "@material-ui/icons/Textsms";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';

const aSelectedInstanceFields = {
  DMSId: { type: "string", fieldName: "dmsId" },
  ClientName: { type: "string", fieldName: "clientName" },
  DeployRegion: { type: "object", fieldName: "deployRegion" },
  SAPContractID: { type: "object", fieldName: "sapContractId" },
  AaamPlatformType: { type: "object", fieldName: "aaamPlatformType" },
};

/**
 * Plain Instance Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const Cia = ({
  values, // the value would be changed by user's input
  updateCIAForm, //the function to update PIForm values which is from redux
  updateASelectedInstanceByField,
  createdBy, // user's EID
  checkDomainAvaliable, // the function that check whether DomainContextRoot exist or not from redux
  isRootExist, // the value that show whether DomainContextRoot exist or not from redux
  setIsAllValid, // the function to check whether all validations are satisfieds
  selectedEnvironment,
  getSelectedEnvironment,
  minDate,
  maxDate,
  getServiceEndDate,
  isServiceEndDateInvalid,
  getNotesValue,
  notesValidations,
  configurationType,
  classes,
  history,
  vendorName,
  email,
  idToken,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
  formClickSubmit
}) => {

  const config = configurationType === "quick";

  // check whether values are valid
  const [isServiceNowTicketValid, setIsServiceNowTicketValid] = useState(true);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDailyDataVolumeValid, setIsDailyDataVolumeValid] = useState(true);
  const [isConcurrentUsersValid, setIsConcurrentUsersValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  //   const [isUsersFieldValid, setUsersField] = useState(false);
  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [domainContextRoot, setDomainContextRoot] = useState("[__]");
  const [regionCode, setRegionCode] = useState("[__]");
  const [customURL, setCustomURL] = useState("https://[__].mywizard-aiops.accenture.com/[__]");
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");

  // Enhanced validation with borders and dialog
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);

  useEffect(() => {
    updateASelectedInstanceByField({
      field: "aaamPlatformType",
      value: {
        Value: "myWizard AiOps Plain Instance",
      },
    });
  }, []);

  useEffect(() => {
    if (config) {
      setDomainContextRoot("[__]");
      setRegionCode("[__]");
    }
  }, [config]);

  if (config) {
    updateCIAForm("ClientName", "")
    updateCIAForm("EndToEndUId", "")
    updateCIAForm("Company", "")
    updateCIAForm("AvanadeCountry", "")
    updateCIAForm("AccentureCountry", "")
  }

  if (!config) {
    if (externalClientData) {
      updateCIAForm("ClientName", externalClientData[0])
      updateCIAForm("EndToEndUId", externalClientData[1])
      // updateCIAForm("Company", externalClientData[2])
      // updateCIAForm("AvanadeCountry", externalClientData[3])
      // updateCIAForm("AccentureCountry", externalClientData[4])
    }
  }

  // const sapValue = document.getElementById("SAPContractID");
  // if (sapValue) {
  //   if (sapValue.value === "") {
  //     document.getElementById("clientDetails").style.display = "none";
  //     const verifiedIcon = document.getElementById("verifiedIcon")
  //     if (verifiedIcon) {
  //       verifiedIcon.style.display = "none";
  //     }
  //   } else {
  //     document.getElementById("clientDetails").style.display = "block";
  //   }
  // }

  // (isServiceNowTicketValid ||
  //   isWBSECodeValid ||
  //   isDailyDataVolumeValid ||
  //   isConcurrentUsersValid ||
  //   isBenefitsExpectedValid) &&
  // !isServiceEndDateInvalid
  //   ? setIsAllValid(true)
  //   : setIsAllValid(false);

  if (!config) {
    (isDailyDataVolumeValid &&
      isConcurrentUsersValid &&
      isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isServiceNowTicketValid && isProjectNameValid && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else {
    (isServiceNowTicketValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isProjectNameValid && isTeamNameSelected
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  updateCIAForm("InstanceType", history.location.state.InstanceType)
  updateCIAForm("VendorName", vendorName);
  updateCIAForm("ConfigurationType", configurationType);

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate") {
      updateCIAForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateCIAForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateCIAForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    }
    else {
      const value = event.target.value;
      event.preventDefault();
      updateCIAForm(fieldName, value);
      // if (fieldName === "Environment") {
      //   getSelectedEnvironment(value);
      // }
      if (fieldName === "RITM") {
        setIsServiceNowTicketValid(checkServiceNowTicket(value));
      }
      if (fieldName === "WBSEcode") {
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "DailyDataVolume") {
        if (value[0] === "0") {
          setIsDailyDataVolumeValid(false);
        } else if (parseInt(value, 10) > 200) {
          setIsDailyDataVolumeValid(false);
        } else {
          setIsDailyDataVolumeValid(checkDailyDataVolume(value));
        }
      }
      if (fieldName === "ConcurrentUsers") {
        setIsConcurrentUsersValid(checkConcurrentUsers(value));
      }
      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }
      //update aSelectedInstance as other step relies on this data
      if (aSelectedInstanceFields[fieldName]) {
        const afieldDetails = aSelectedInstanceFields[fieldName];
        afieldDetails.type === "string" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value,
          });
        afieldDetails.type === "object" &&
          updateASelectedInstanceByField({
            field: afieldDetails.fieldName,
            value: {
              Value: value,
            },
          });
      }

      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (fieldName === "DeploymentRegion") {
        if (value == "sydney") {
          setRegionCode("dh")
        } else if (value == "virginia") {
          setRegionCode("dh1")
        } else if (value == "frankfurt") {
          setRegionCode("dh2")
        } else if (value == "singapore") {
          setRegionCode("dh3")
        } else if (value == "tokyo") {
          setRegionCode("dh4")
        } else if (value == "ireland") {
          setRegionCode("dh5")
        } else if (value == "london") {
          setRegionCode("dh6")
        } else {
          setRegionCode("[__]")
        }
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction" || value === "AppTeam-Testing") {
          setEnv("Test")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
        } else {
          setEnv("")
        }
      }
    }
  };

  getSelectedEnvironment(env);
  //default env is production
  updateCIAForm("Environment", 'Production');

  // user can only input lower case letter and numbers in DomainContextRoot
  const handleChangeRoot = (event, fieldName) => {
    const re = /^[a-z0-9]*$/;
    const value = event.target.value;
    re.test(value) && updateCIAForm(fieldName, value);
    setDomainContextRoot(value)
  };

  const handleChangeRootSuggestions = (event, value, fieldName) => {
    const re = /^[a-z0-9]*$/;
    // const value = event.target.value;
    re.test(value) && updateCIAForm(fieldName, value);
    setDomainContextRoot(value)
  };

  // it would check whether the root has existed from DB once user stop typing longer than 0.3s
  const debouncedValue = useDebounce(domainContextRoot, 300);
  useEffect(() => {
    debouncedValue && checkDomainAvaliable(debouncedValue);
  }, [debouncedValue]);

  const isGDPR = values.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateCIAForm(fieldName, value);
  };
  
  //form validation
  const validateInputFields = (step) => {
    // Only validate on final submit or when explicitly called with 'submit'
    if (step !== 'submit') {
      return true; // Skip validation for intermediate steps
    }

    let ispass = true;
    const missingFields = [];

    // Collect all required fields for final validation
    let allRequiredFields = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DeploymentRegion',
      'TentativeServiceEndDate',
      'AdminDistributionGroup',
      'DomainContextRoot'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      allRequiredFields.push('SAPContractID');
    }

    // Check each required field
    for (const fieldname of allRequiredFields) {
      let isFieldInvalid = false;

      if (fieldname === "WBSEcode" && (!values[fieldname] || values[fieldname] === "" || !isWBSEValid)) {
        isFieldInvalid = true;
        missingFields.push(`${fieldname} (${!isWBSEValid ? 'Invalid WBSE code' : 'Required'})`);
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (!values[fieldname] || values[fieldname] === "") {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      }

      if (isFieldInvalid) {
        ispass = false;
      }
    }

    // Use the new validation handler
    handleValidationResult(ispass, missingFields, formClickSubmit);

    return ispass;
  }

  return (
    <>
      <GeneralForm
        FormId={vendorName === "MCC" ? 0 : 17}
        validateInputFields={validateInputFields}
        ProvisionDetails={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              {!config &&
                <Grid item xs={4}>
                  {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                </Grid>}

              {sapContractCodeLength == 10 && sapContractCodeLength != 0 && !isExternalClientLoading && !externalClientError
                ? !config &&
                <Grid item xs={4}> {PlatformFormField.ClientNamePlatformField(values, handleChange, externalClientData[0])}</Grid>
                : ""
              }

              {sapContractCodeLength == 10 && !isExternalClientLoading && !externalClientError ?
                !config &&
                <Grid item xs={4}> {PlatformFormField.EndToEndUIdPlatformField(values, handleChange, externalClientData[1])}</Grid>
                : ""
              }

              <Grid item xs={4}>
                {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
              </Grid>
              <Grid item xs={4}>
                {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSEValid, isLoading)}
              </Grid >
              <Grid item xs={4}>
                {FormField.SecondaryContact(handleChange, values, config)}
              </Grid>
              <Grid item xs={4}>
                {PlatformFormField.DeploymentRegionPlatformField(
                  values,
                  handleChange
                )}
              </Grid>
              <Grid item xs={4}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    // selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
              <Grid item xs={4}>
                {FormField.AdminDistributionGroupField(handleChange, values)}
              </Grid>
              <Grid item xs={4}>
                {!config ? PlatformFormField.DomainContextRootPlatformFieldClient(
                  values,
                  handleChangeRootSuggestions,
                  // handleChangeRoot,
                  isRootExist,
                  rootExistedHint,
                  rootWrongFormatHint,
                  externalClientData,
                  domainContextRoot,
                  isLoading
                ) : PlatformFormField.DomainContextRootPlatformField(
                  values,
                  handleChangeRoot,
                  isRootExist,
                  rootExistedHint,
                  isLoading
                )}
              </Grid>
            </Grid>

          </div>
        }
        productname={'CIA'}
        history={history}
        customurl={`https://${regionCode}-${domainContextRoot}.genwizardsd.com`}
      ></GeneralForm>
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  isRootExist: state.fui.isRootExist,
  isWBSEValid: state.fui.isWBSEValid,
  values: state.fui.CIAForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
  updateCIAForm: fuiRedux.updateCIAForm,
  updateASelectedInstanceByField: fuiRedux.updateASelectedInstanceByField,
  checkDomainAvaliable: fuiRedux.checkRootExisted,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(Cia));
